<template>
    <div class="background">
        <div class="title">
            设备自检成功
        </div>
        <div class="device-number">
            编号: {{ boxNumber }}
        </div>
        <a-icon
            class="ok-icon"
            theme="filled"
            type="check-circle" />
        <div class="note">
            自检成功，可以出厂激活了
        </div>
        <div class="bottom-button-area">
            <div
                v-on:click="ok"
                class="button">
                完成
            </div>
        </div>
    </div>
</template>

<script>
 import Vue from 'vue';

 export default {
     name: 'TestOK',
     data() {
         return {
             boxNumber: "未知"
         }
     },
     props: {
     },
     components: {
     },
     mounted() {
         if (sessionStorage.getItem("testOkNumber")) {
             this.boxNumber = sessionStorage.getItem("testOkNumber")
             sessionStorage.setItem("testOkNumber", "")
         }
     },
     methods: {
         ok() {
             this.$router.replace("/home")
         }
     }
 }
</script>

<style scoped>
 .background {
     width: 100%;
     height: 100%;
     position: relative;
 }

 .title {
     font-size: 30px;
     padding-top: 40px;
 }

 .device-number {
     font-size: 20px;
     font-weight: bold;
     margin-top: 10px;
     margin-bottom: 10px;
 }

 .ok-icon {
     margin-top: 30%;
     margin-bottom: 20px;
     font-size: 100px;
     color: #09BB07;
 }

 .note {
     font-size: 18px;
 }

 .bottom-button-area {
     width: 100%;
     position: absolute;
     bottom: 30px;
     display: flex;
     flex-direction: row;
     justify-content: center;
 }

 .button {
     width: 50%;
     background-color: #20273E;
     height: 40px;
     border-radius: 50px;
     color: white;
     font-size: 15px;
     border: none;
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
 }
</style>
